import tapIcon from '@assets/tap.svg';
import { SandboxMessageScreen } from '@/components/Sandbox/SandboxMessageScreen/SandboxMessageScreen';
import { AuthenticateScreen } from '../AuthenticateScreen/AuthenticateScreen';

export const CustomTapRender = (wrappedComponent: any) => {
  const { state } = wrappedComponent;

  if (state.airKeyPayload) {
    return wrappedComponent.renderPayloadReceived();
  }

  if (!state.doReadCard) {
    return (
      <AuthenticateScreen
        onAccept={wrappedComponent.startReadAirKeyCard}
        onUnrecognized={wrappedComponent.cancelNdefAndClose}
      />
    );
  }

  return (
    <SandboxMessageScreen icon={tapIcon}>
      <h3
        style={{
          fontSize: '20px',
          fontWeight: 600,
          textAlign: 'center',
          marginTop: '32px',
          width: '100%',
        }}
      >
        Grab your AirKey card
      </h3>
      <ul style={{ color: 'white' }}>
        <li style={{ marginTop: '12px' }}>
          Hold your card flat against the back of your phone, with the
          card&apos;s magnetic stripe facing the phone.
        </li>
        <li style={{ marginTop: '12px' }}>
          If nothing happens, try moving your card to a different position.
        </li>
      </ul>
    </SandboxMessageScreen>
  );
};
